import { EServiceType } from 'ts/interfaces/services/service';

export const SSE_SERVICES_LIST = [
  EServiceType.CONVERTOR,
  EServiceType.COMPRESSOR,
  EServiceType.OCR,
  EServiceType.MERGER,
  EServiceType.TRANSLATE,
  EServiceType.CONVERTER,
  EServiceType.IMAGE_TO_TEXT
];
